import { FormControl, OutlinedInput } from '@mui/material';
import { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';
import { classes, ClassType } from '../../../lib/utils/cssUtils';
import styles from './Input.module.scss';

const Input = ({
  inputProps,
  className,
  classes: inputClasses,
  ...rest
}: Omit<OutlinedInputProps, 'className'> & { className?: ClassType }) => {
  return (
    <FormControl className={classes(styles.inputContainer, className)}>
      <OutlinedInput
        classes={{ ...inputClasses, root: styles.inputWrapper, input: styles.input }}
        inputProps={{ ...inputProps, className: styles.placeholder }}
        {...rest}
      />
    </FormControl>
  );
};

export default Input;
